module.exports = __webpack_public_path__ + "static/media/action_myturn.7e4b4f68.mp3";